<!--
 Copyright (c) 2019
    Reliant Business Valuation, LLC - http://reliantvalue.com
    Author: Ronnel Bedana - ronnel@internalvaluation.com

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
-->

<button class="toggle-button hinted" [disabled]="disabled" (click)="openModal($event, EditClientNotes)">
  <fa name="fa fa-sticky-note-o"></fa>
  <template #target></template>
</button>

<!-- Modal to edit notes of client -->
<ng-template #EditClientNotes>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Edit Client</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group mb-0">
      <label>Notes</label>
      <textarea class="form-control" placeholder="Notes" name="NOTES" rows="3"
        [(ngModel)]="notesEdit"></textarea>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-rbv default" (click)="closeModal()" style="margin-right: 10px;">
      Cancel
    </button>
    <button class="btn btn-rbv" (click)="updateValue()">
      Update
    </button>
  </div>
</ng-template>
